import { Link, useLocation } from 'react-router-dom';
import { DESIGN_UPDATE_FAQ, useDesignUpdate } from '../../lib/designUpdate';
import '../../styles/gbr-designupdate.css';

/** Slim strip above every page. It sits in the normal page flow, so it never covers anything. */
export function DesignUpdateStrip() {
  const { show, dismiss } = useDesignUpdate();
  const { pathname } = useLocation();
  if (!show || pathname.startsWith('/admin')) return null;
  return (
    <div className="dn-bar" role="note">
      <p>
        <b>New look</b> – Credits are now Bookmarks. <Link to={DESIGN_UPDATE_FAQ}>Learn more →</Link>
      </p>
      <button type="button" className="dn-x" onClick={dismiss} aria-label="Dismiss this notice">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
      </button>
    </div>
  );
}

/** Small (i) next to Bookmarks / Golden Quills numbers; leads to the FAQ entry. */
export function DesignUpdateInfo() {
  const { show } = useDesignUpdate();
  if (!show) return null;
  return (
    <Link to={DESIGN_UPDATE_FAQ} className="dn-i" aria-label="Why are Credits now called Bookmarks? Read the FAQ entry" title="Credits are now Bookmarks, Diamonds are now Golden Quills">
      i
    </Link>
  );
}
